import React from "react";

import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
    LocalOffer as SeoIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import brandsService from "../../../services/brands.service";
import SeoFormModalContent from "./seo_form";

const headerCells = [
    {
        field: "name",
        title: "نام",
        mainField: true,
    },
    {
        field: "logoCol",
        title: "لوگو",
        mainField: false,
    },
    {
        field: "imageCol",
        title: "عکس",
        mainField: false,
    },
];
const defaultKeys = [
    {
        title: "نام",
        field: "name",
        active: true,
    },
];

export default function BrandsPage() {
    const deleteItem = (item) => {
        return brandsService.deleteBrand(item.id);
    };

    const changeData = (data) => {
        return data.map(item => {
            if (item.logo) {
                item.logoCol = (
                    <img src={item.logo} className="brand-logo" />
                );
            }

            if (item.image) {
                item.imageCol = (
                    <img src={item.image} className="brand-image" />
                );
            }

            return item
        })
    }

    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                backend={brandsService.getBrandsUrl}
                changeData={changeData}
                rowActions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <EditIcon />,
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <SeoIcon />,
                        modalContent: (props) => <SeoFormModalContent {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد برند",
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                ]}
                searchKeys={defaultKeys}
                title="برندها"
            />
        </div>
    );
}
